import { zergApi } from "@/service/zerg";
import axios from "axios";

class EmployeeServices {


    async getEmployees(payload) {
        try {
            const data = await zergApi.post('/rrhh/employee/list', payload);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async getEntitiesGroup() {
        try {
            const data = await zergApi.get('/setting/entity-group/get-select-entity-group');
            return data;
        } catch (error) {
            throw error;
        }
    }

    async getBonusForSelect(params) {
        try {
            const data = await zergApi.post('/setting/payroll/bonus/get-bonus-for-select', params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async getNewsPersonalsOldSoft(params) {
        try {
            const config = {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded' // Aquí puedes cambiar el tipo de contenido
                }
            };
            const data = await axios.post('https://old.rosymarperu.in/server/public/index.php/cronjob/tareo/get_news_personals', params, config)
            return data;
        } catch (error) {
            throw error;
        }
    }

    async getLastEmployeeId(params) {
        try {
            const data = await zergApi.get("/rrhh/employee/get-last-employee-id", params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async insertNewsEmployeesOfOldSot(params) {
        try {
            const data = await zergApi.post("/rrhh/employee/insert-news-employees", params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async updateEmployeeInformation(params) {
        try {
            const data = await zergApi.post("/rrhh/employee/update-employee-information", params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async updateJobDetails(params) {
        try {
            const data = await zergApi.post("/rrhh/employee/update-employee-job-detail", params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async getEmployeeDashboard(params) {
        try {
            const data = await zergApi.post("/rrhh/employee/get-employee", params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async getAllDocumentTypes(params) {
        try {
            const data = await zergApi.get("/rrhh/employee/get-document-types", params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async getAllMartial(params) {
        try {
            const data = await zergApi.get("/rrhh/employee/get-martials", params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async getAllRelations(params) {
        try {
            const data = await zergApi.get("/rrhh/employee/get-relations", params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async getEmployeeInformation(params) {
        try {
            const data = await zergApi.post("/rrhh/employee/get-employee-information", params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async getJobDetailsInformation(params) {
        try {
            const data = await zergApi.post("/rrhh/employee/get-jobdetails-information", params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async getAllAreas(params) {
        try {
            const data = await zergApi.post("/rrhh/employee/get-all-areas", params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async getRolByDepartment(params) {
        try {
            const data = await zergApi.post("/rrhh/employee/get-roles-department", params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async createEmployee(params) {
        try {
            const data = await zergApi.post("/rrhh/employee/create-employee", params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async getCountries(params) {
        try {
            const data = await zergApi.post("/rrhh/employee/get-countries", params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async getLaborRegimes(params) {
        try {
            const data = await zergApi.post("/rrhh/employee/get-labor-regimes", params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async getViaticTracking(params) {
        try {
            const data = await zergApi.post("/rrhh/employee/get-employee-viatic-tracking", params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async generateCodeAttendance(params) {
        try {
            const data = await zergApi.post("/rrhh/employee/generate-code-attendance", params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async updatePhoto(params) {
        try {
            const data = await zergApi.post("/rrhh/employee/update-photo", params, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            return data;
        } catch (error) {
            throw error;
        }
    }

    async generateWorkSheetPdf(params) {
        try {
            const data = await zergApi.post("/rrhh/employee/generate-worksheet-pdf", params, { responseType: "blob" });
            return data;
        } catch (error) {
            throw error;
        }
    }
    async getBanks(params) {
        try {
            const data = await zergApi.post("/rrhh/banks/get-banks", params);
            return data;
        } catch (error) {
            throw error;
        }
    }
    async getBankAccountTypes(params) {
        try {
            const data = await zergApi.post("/rrhh/bank-account-types/get-bank-account-types", params);
            return data;
        } catch (error) {
            throw error;
        }
    }
    async changeStatusBankAccount(params) {
        try {
            const data = await zergApi.post("/rrhh/employee-bank-account/change-status-bank-account", params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async getEmployeeSchedule(params) {
        try {
            const data = await zergApi.post("/rrhh/employee/get-employee-schedule", params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async updateEmployeeSchedule(params) {
        try {
            const data = await zergApi.post("/rrhh/employee/update-employee-schedule", params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async updateMultipleEmployeeSchedule(params) {
        try {
            const data = await zergApi.post("/rrhh/employee/update-multiple-employee-schedule", params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async inactiveEmployeeById(params) {
        try {
            const data = await zergApi.post("/rrhh/employee/inactive-employee-by-id", params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async activeEmployeeById(params) {
        try {
            const data = await zergApi.post("/rrhh/employee/active-employee-by-id", params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async getPayrollDates(params) {
        try {
            const data = await zergApi.post("/rrhh/payroll/employee/get-payroll-dates", params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async getPayrollPdf(params) {
        try {
            const data = await zergApi.post("/rrhh/payroll/employee/get-payroll-pdf", params, { responseType: "blob" });
            return data;
        } catch (error) {
            throw error;
        }
    }

    async getEmployeeVacations(params) {
        try {
            const data = await zergApi.post("/rrhh/employee/get-employee-vacations", params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async getEmployeesByType(params){
        try {
            const data = await zergApi.post("/rrhh/employee/get-employee-by-type",params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async getHistorialSueldos(params){
        try {
            const data = await zergApi.post("/rrhh/employee/get-historial-sueldos",params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async getHistorialLiquidaciones(params){
        try {
            const data = await zergApi.post("/rrhh/employee/get-historial-liquidaciones",params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async cesarEmpleado(params){
        try {
            const data = await zergApi.post("/rrhh/employee/cesar-empleado",params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async anularCese(params){
        try {
            const data = await zergApi.post("/rrhh/employee/anular-cese",params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async getMotivosCese(params = {}){
        try {
            const data = await zergApi.post("/rrhh/liquidaciones/motivos-cese", params);
            return data;
        } catch (error) {
            throw error;
        }
    }
}

export default new EmployeeServices();